import {Exclude} from 'class-transformer';

import {AnswerOption} from './answer-option';
import {QuestionType} from './question-type';

export class MessageQuestionType implements QuestionType {

  public name: string = 'message';
  @Exclude({toPlainOnly: true})
  public prettyName: string = 'Nachricht';
  @Exclude({toPlainOnly: true})
  public icon: string = 'comment';

  public getAnswerOptions(): Array<AnswerOption> {
    return [{
      label: '',
      value: '',
    }];
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/questions/message-question-type.ts